// extracted by mini-css-extract-plugin
export default {"dialDiv":"speedDial_dialDiv__U8V+H","dialDivFileRes":"speedDial_dialDivFileRes__J6JXH"};